<!-- PROMO -->
<div class="promo-grid">
  <!-- Banner 1: Guías Prepagadas -->
  <a href="https://pmm.com.mx/prepago" target="_blank" rel="noopener" class="promo-blue">
    <h2>Guías Prepagadas</h2>
    <p>Impulsa las ventas de tu negocio con nuestros paquetes a precios preferenciales.</p>
    <span class="btn-outline-white" style="width:fit-content">Entrar →</span>
  </a>

  <!-- Banner 2: Servicio para Empresas -->
  <a href="http://www.pmmentuempresa.com" target="_blank" rel="noopener" class="promo-white">
    <div class="promo-deco"></div>
    <div class="promo-badge-o">B2B Logística</div>
    <h2>Servicio para Empresas</h2>
    <p>Soluciones integrales adaptadas a tu cadena de suministro. Confiabilidad total.</p>
    <span class="btn-orange" style="width:fit-content">Entrar →</span>
  </a>

  <!-- Notas adicionales -->
  <a routerLink="/ayuda/3" class="info-strip">
    <div class="info-icon">
      <svg viewBox="0 0 24 24" fill="none" stroke="#1d4ed8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="20" height="20"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>
    </div>
    <div>
      <h3>Consejos de Embalaje</h3>
      <p>Aprende a proteger tus envíos correctamente.</p>
    </div>
  </a>
  <a routerLink="/cobertura" class="info-strip">
    <div class="info-icon green">
      <svg viewBox="0 0 24 24" fill="none" stroke="#16a34a" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="20" height="20"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z"/></svg>
    </div>
    <div>
      <h3>Envíos a distintas ciudades</h3>
      <p>Conoce nuestra extensa red de cobertura nacional.</p>
    </div>
  </a>
</div>

<!-- Modal -->
<div *ngIf="showModal" class="fixed inset-0 z-50 flex items-center justify-center p-4" role="dialog" aria-modal="true" aria-label="Selecciona acceso">
  <button type="button" class="absolute inset-0 bg-slate-900/50" (click)="hideModal()" aria-label="Cerrar modal"></button>
  <div class="relative w-full max-w-2xl rounded-2xl bg-white shadow-2xl p-6">
    <div class="flex items-center justify-between mb-5">
      <h3 class="text-xl font-bold text-slate-800 m-0">Selecciona acceso</h3>
      <button type="button" class="inline-flex h-9 w-9 items-center justify-center rounded-full border border-slate-200 text-slate-500 hover:bg-slate-100" (click)="hideModal()" aria-label="Cerrar">
        <i class="fas fa-times"></i>
      </button>
    </div>
    <div class="grid grid-cols-2 gap-4">
      <a class="flex flex-col items-center p-4 rounded-xl border border-slate-200 hover:bg-slate-50 transition-colors no-underline text-slate-800"
        *ngFor="let sitio of elaboraGuia"
        [href]="sitio.link"
        target="_blank"
        rel="noopener"
        (click)="hideModal()">
        <fa-icon [icon]="icons[sitio.icon]" size="2x" class="mb-2 text-blue-600"></fa-icon>
        <span class="text-sm font-medium">{{ sitio.titulo }}</span>
      </a>
    </div>
  </div>
</div>
